module.exports = __webpack_public_path__ + "static/PersonalLoan-NZ-F4-9f696f09b2b1669e8a11f1ddec36c92a.webp";